var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebcaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1704 16.6686L27.8556 14.0406C29.5302 12.4018 32.2451 12.4018 33.9196 14.0406L36.6048 16.6686L30.8877 22.2639L25.1704 16.6686Z",
    fill: "#B5D900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36124 16.6102L5.04644 13.9823C6.72096 12.3435 9.4359 12.3435 11.1104 13.9823L13.7956 16.6102L8.07843 22.2056L2.36124 16.6102Z",
    fill: "#39B4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0022 22.2502L13.7194 16.5647L19.4366 22.2502L16.7514 24.9206C15.0769 26.5859 12.3619 26.5859 10.6874 24.9206L8.0022 22.2502Z",
    fill: "#006872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0022 22.2502L13.7194 16.5647L19.4366 22.2502L16.7514 24.9206C15.0769 26.5859 12.3619 26.5859 10.6874 24.9206L8.0022 22.2502Z",
    fill: "#39B4BF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 22.2502L25.1537 16.5647L30.8709 22.2502L28.1857 24.9206C26.5112 26.5859 23.7962 26.5859 22.1218 24.9206L19.4366 22.2502Z",
    fill: "#006872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 22.2502L25.1537 16.5647L30.9188 22.2502L28.1857 24.9206C26.5112 26.5859 23.7962 26.5859 22.1218 24.9206L19.4366 22.2502Z",
    fill: "#B5D900",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6693 16.5225L16.4808 13.9823C18.1554 12.3435 20.8703 12.3435 22.5448 13.9823L25.23 16.6102L19.4191 22.2724L13.6693 16.5225Z",
    fill: "#006872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1704 16.6686L27.8556 14.0406C29.5302 12.4018 32.2451 12.4018 33.9196 14.0406L36.6048 16.6686L30.8877 22.2639L25.1704 16.6686Z",
    fill: "#B5D900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36124 16.6102L5.04644 13.9823C6.72096 12.3435 9.4359 12.3435 11.1104 13.9823L13.7956 16.6102L8.07843 22.2056L2.36124 16.6102Z",
    fill: "#39B4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0022 22.2502L13.7194 16.5647L19.4366 22.2502L16.7514 24.9206C15.0769 26.5859 12.3619 26.5859 10.6874 24.9206L8.0022 22.2502Z",
    fill: "#006872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0022 22.2502L13.7194 16.5647L19.4366 22.2502L16.7514 24.9206C15.0769 26.5859 12.3619 26.5859 10.6874 24.9206L8.0022 22.2502Z",
    fill: "#39B4BF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 22.2502L25.1537 16.5647L30.8709 22.2502L28.1857 24.9206C26.5112 26.5859 23.7962 26.5859 22.1218 24.9206L19.4366 22.2502Z",
    fill: "#006872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 22.2502L25.1537 16.5647L30.9188 22.2502L28.1857 24.9206C26.5112 26.5859 23.7962 26.5859 22.1218 24.9206L19.4366 22.2502Z",
    fill: "#B5D900",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6693 16.5225L16.4808 13.9823C18.1554 12.3435 20.8703 12.3435 22.5448 13.9823L25.23 16.6102L19.4191 22.2724L13.6693 16.5225Z",
    fill: "#006872"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcaster);
export default __webpack_public_path__ + "static/media/webcaster.22659f26b0e80dfa19425fbc342e4de0.svg";
export { ForwardRef as ReactComponent };